import { IOfferDescription } from "./IOfferDescription";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 12.04.13
 * Time: 15:14
 */

import { Constants_Offer } from "../Constants_Offer";
import { OfferDescriptionDictionary } from "../OfferDescriptionDictionary";

/**
 * Defines C2 cost for offer acception
 */
export class OfferDescriptionCostC2 implements IOfferDescription {
    private _costC2: number = 0;

    constructor(costC2: number = 0) {
        if (costC2 != 0) {
            this._costC2 = costC2;
        }
    }

    public get name(): string {
        return Constants_Offer.OFFER_COST_C2;
    }

    public registerOfferDescription(dictonary: OfferDescriptionDictionary): void {
        dictonary.addEntry(this.name, this);
    }

    public parseFromObjectParam(params: any): void {
        this._costC2 = (<number>params);
    }

    public get costC2(): number {
        return this._costC2;
    }

    public dispose(): void {
    }
}

